import { render, staticRenderFns } from "./CartWidget.vue?vue&type=template&id=0511d796&scoped=true&"
import script from "./CartWidget.vue?vue&type=script&lang=js&"
export * from "./CartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0511d796",
  null
  
)

export default component.exports